import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: import.meta.env.REACT_APP_API_URL || 'https://jewel-posapi.appsinlive.in/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      // Get base path from window location
      const basePath = window.location.pathname.split('/').slice(0, -1).join('/') || '';
      window.location.href = `${basePath}/login`;
    }
    return Promise.reject(error);
  }
);

export default api;
